import React, { Component } from "react";
import Sundial from "./components/sundial";
import moment from "moment";
import SmuLogo from "./static/SM_horizontal.svg";
import Hero from "./components/hero";

const play = (
    <svg
        width="1792"
        height="1792"
        viewBox="0 0 1792 1792"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M1576 927l-1328 738q-23 13-39.5 3t-16.5-36v-1472q0-26 16.5-36t39.5 3l1328 738q23 13 23 31t-23 31z" />
    </svg>
);
const stop = (
    <svg
        width="1792"
        height="1792"
        viewBox="0 0 1792 1792"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M1664 192v1408q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h512q26 0 45 19t19 45zm-896 0v1408q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h512q26 0 45 19t19 45z" />
    </svg>
);

const repeat = (
    <svg
        width="1792"
        height="1792"
        viewBox="0 0 1792 1792"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M1664 256v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39 14-69l138-138q-148-137-349-137-104 0-198.5 40.5t-163.5 109.5-109.5 163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5q119 0 225-52t179-147q7-10 23-12 15 0 25 9l137 138q9 8 9.5 20.5t-7.5 22.5q-109 132-264 204.5t-327 72.5q-156 0-298-61t-245-164-164-245-61-298 61-298 164-245 245-164 298-61q147 0 284.5 55.5t244.5 156.5l130-129q29-31 70-14 39 17 39 59z" />
    </svg>
);

var today = moment.utc(); //.add(0.5, "year")

let cities = [
    {
        name: "London",
        key: "London",
        shadowImage: "london.svg",
        tz: "+00:00",
        coords: { lat: 51.51279, lng: -0.09184 },
    },
    {
        name: "Paris",
        key: "Paris",
        shadowImage: "paris.svg",
        tz: "+01:00",
        coords: { lat: 48.864716, lng: 2.349014 },
    },
    {
        name: "Cairo",
        key: "Cairo",
        shadowImage: "cairo.svg",
        tz: "+02:00",
        coords: { lat: 30.0444, lng: 31.2357 },
    },
    {
        name: "Moscow",
        key: "Moscow",
        shadowImage: "moscow.svg",
        tz: "+03:00",
        coords: { lat: 55.7558, lng: 37.6173 },
    },
    {
        name: "Dubai",
        key: "Dubai",
        shadowImage: "dubai.svg",
        tz: "+04:00",
        coords: { lat: 25.2048, lng: 55.2708 },
    },
    {
        name: "New Delhi",
        key: "New Delhi",
        shadowImage: "new-delhi.svg",
        tz: "+05:30",
        coords: { lat: 28.6448, lng: 77.216721 },
    },
    {
        name: "Bangkok",
        key: "Bangkok",
        shadowImage: "bangkok.svg",
        tz: "+07:00",
        coords: { lat: 13.7563, lng: 100.5018 },
    },
    {
        name: "Jakarta",
        key: "Jakarta",
        shadowImage: "jakarta.svg",
        tz: "+07:00",
        coords: { lat: -6.1751, lng: 106.865 },
    },
    {
        name: "Beijing",
        key: "Beijing",
        shadowImage: "beijing.svg",
        tz: "+08:00",
        coords: { lat: 39.9042, lng: 116.4074 },
    },
    {
        name: "Tokyo",
        key: "Tokyo",
        shadowImage: "tokyo.svg",
        tz: "+09:00",
        coords: { lat: 35.6895, lng: 139.6917 },
    },
    {
        name: "Sydney",
        key: "Sydney",
        shadowImage: "sydney.svg",
        tz: "+11:00",
        coords: { lat: -33.865143, lng: 151.2099 },
    },
    {
        name: "Auckland",
        key: "Auckland",
        shadowImage: "auckland.svg",
        tz: "+12:00",
        coords: { lat: -36.8485, lng: 174.7633 },
    },
    {
        name: "Honolulu",
        key: "Honolulu",
        shadowImage: "honolulu.svg",
        tz: "-10:00",
        coords: { lat: 21.3069, lng: -157.8583 },
    },
    {
        name: "Seattle",
        key: "Seattle",
        shadowImage: "seattle.svg",
        tz: "-08:00",
        coords: { lat: 47.6062, lng: -122.3321 },
    },
    {
        name: "Mexico City",
        key: "Mexico City",
        shadowImage: "mexico.svg",
        tz: "-06:00",
        coords: { lat: 19.4326, lng: -99.1332 },
    },
    {
        name: "Toronto",
        key: "Toronto",
        shadowImage: "toronto.svg",
        tz: "-05:00",
        coords: { lat: 43.761539, lng: -79.411079 },
    },
    {
        name: "New York City",
        key: "New York City",
        shadowImage: "new-york.svg",
        tz: "-05:00",
        coords: { lat: 40.73061, lng: -73.935242 },
    },
    {
        name: "Rio de Janeiro",
        key: "Rio de Janeiro",
        shadowImage: "rio.svg",
        tz: "-03:00",
        coords: { lat: -22.9068, lng: -43.1729 },
    },
];

const secretSpots = [
    {
        secret: "martin",
        values: {
            name: "Berlin",
            shadowImage: "auckland.svg",
            tz: "+01:00",
            coords: { lat: 52.520645, lng: 13.409779 },
        },
    },
    {
        secret: "joachim",
        values: {
            name: "Växjö",
            shadowImage: null,
            tz: "+01:00",
            coords: { lat: 56.879, lng: 14.8059 },
        },
    },
    {
        secret: "dasha",
        values: {
            name: "Almaty",
            shadowImage: null,
            tz: "+06:00",
            coords: { lat: 43.2220, lng: 76.8512 },
        },
    },
];

const speeds = [
    { value: 720, label: "Fast (12h/s)" },
    { value: 360, label: "Brisk (6h/s)" },
    { value: 120, label: "Normal (2h/s)" },
    { value: 60, label: "Slow (1h/s)" },
    { value: 20, label: "Snail (20m/s)" },
    { value: -1, label: "Realtime" },
];

let accumulatedTyping = "";


class App extends Component {
    constructor() {
        super();

        const isRealtime = window.location.search === "?rt"

        const playSpeed = isRealtime ? speeds[5].value : speeds[3].value;

        this.state = {
            date: today,
            playing: true,
            playSpeed,
            realtime: isRealtime
        };
        this.handlePlayPauseClick = this.handlePlayPauseClick.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.animationFrameHandler = this.animationFrameHandler.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.lastFrameTime = performance.now();
        this.requestFrame();
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyPress);
    }

    animationFrameHandler(now) {
        const { playSpeed, realtime } = this.state;
        const dt = (now - this.lastFrameTime) / 1000;
        this.lastFrameTime = now;

        const increment = playSpeed * dt;

        if (realtime) {
            today = moment.utc();
        } else {
            today.add(increment, "minutes");
        }
        this.setState({
            date: today,
        });
        this.requestFrame();
    }

    requestFrame() {
        this.animFrame = window.requestAnimationFrame(
            this.animationFrameHandler
        );
    }

    play() {
        this.lastFrameTime = performance.now();
        this.requestFrame();
        this.setState({
            playing: true,
        });
    }

    pause() {
        cancelAnimationFrame(this.animFrame);
        this.setState({
            playing: false,
        });
    }

    handleKeyPress(e) {
        accumulatedTyping += e.key.toLowerCase();
        secretSpots.forEach(secret => {
            if (accumulatedTyping.length >= secret.secret.length) {
                if (accumulatedTyping.endsWith(secret.secret)) {
                    accumulatedTyping = "";
                    cities = cities.map(city => {
                        return {
                            ...city,
                            ...secret.values,
                        };
                    });
                }
            }
        });
    }

    handlePlayPauseClick() {
        const newState = !this.state.playing;
        if (newState) {
            this.play();
        } else {
            this.pause();
        }
    }

    handleReset(e) {
        today = moment.utc();
        this.setState({
            date: today,
        });
        if (!this.state.playing) {
            this.play();
        }
    }

    renderControls() {
        const icon = this.state.playing ? stop : play;

        const speedItems = speeds.map(s => {
            return (
                <div
                    key={s.label}
                    className="speed-item"
                    data-active={this.state.playSpeed === s.value}
                    onClick={() =>
                        this.setState({
                            playSpeed: s.value,
                            realtime: s.value === -1,
                        })
                    }
                >
                    {s.label}
                </div>
            );
        });

        return (
            <div className="controls">
                <div className="buttons">
                    <button
                        className="play"
                        onClick={this.handlePlayPauseClick}
                    >
                        {icon}
                    </button>
                    <button className="reset" onClick={this.handleReset}>
                        {repeat}
                    </button>
                </div>
                <h5>Speed control:</h5>
                <div className="speed-container">{speedItems}</div>
            </div>
        );
    }

    renderInfo() {
        const localTime = this.state.date.local().format("HH:mm");
        const localDate = this.state.date.local().format("ddd, MMM DD YYYY");
        return (
            <div className="info">
                <div className="info-container">
                    <h1 className="app-title">Hello, sun.</h1>
                    <h4>Your local time is</h4>
                    <h2>{localTime}</h2>
                    <h3>{localDate}</h3>
                    <p>
                        Explore the paths of the sun and moon across the
                        different time zones of the world
                    </p>
                    {this.renderControls()}
                    <div className="info-credits-main">
                        {this.renderCredits()}
                    </div>
                </div>
            </div>
        );
    }

    renderCredits() {
        return (
            <div className="info-credits">
                <a href="https://smallmultiples.com.au">
                    <img className="logo-image" src={SmuLogo} alt="A Small Multiples Project"/>
                </a>
                <ul>
                    <li>Concept + Creative Direction: Jack Zhao</li>
                    <li>Design + Web Development: Harry Morris</li>
                    <li>Design Support: Dasha Yurovskaya</li>
                    <li>iOS App Development: Clément Balestrat and Harry Morris</li>
                </ul>
            </div>
        );
    }

    renderDials() {
        const dials = cities.map(city => {
            let theDate = today.clone();
            theDate.utcOffset(city.tz);
            return (
                <Sundial
                    key={city.key}
                    city={city.name}
                    coords={city.coords}
                    date={theDate}
                    tz={city.tz}
                    shadowImage={city.shadowImage ? require("./static/" + city.shadowImage) : null}
                />
            );
        });
        return <div className="dials">{dials}</div>;
    }

    renderAppSection() {
        const city = cities[16]; // mexico
        let theDate = today.clone();
        theDate.utcOffset(city.tz);
        return (
            <div className="section-app">
                <Hero
                    date={theDate}
                    coords={city.coords}
                />
            </div>
        )
    }

    renderSundialSection() {
        return (
            <div className="section-sundial">
                {this.renderInfo()}
                {this.renderDials()}
                <div className="info-credits-bottom">
                    {this.renderCredits()}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="App">
                {this.renderAppSection()}
                {this.renderSundialSection()}
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js